import Logo from '../../assets/images/static/Logo_white.svg';

const Loader = () => {
  return (
    <div className="loader">
      <img src={Logo} alt="Logo" />
    </div>
  );
};

export default Loader;